module.exports = __webpack_public_path__ + "tag-operation.svg?f4c248769c7ca2b73a4d79c71299db7c";